<template>
  <b-container v-if="this.type">
    <h1 v-translate="{type: $appConfig.models[this.type].title}" v-if="!inModal">New %{type}</h1>
    <b-alert
      :show="dismissCountDown"
      dismissible
      variant="success"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
        <translate>The Item has been updated</translate>
    </b-alert>
    <b-form @submit.prevent="postItem">
      <b-form-row
        class="mb-3"
        :id="'fieldsetHorizontal' + index"
        v-for="(field, index) in fields"
        v-if="field.key !== 'id'"
        :key="index"
      >
        <b-col sm="4" lg="3">
          <label id="fieldsetHorizontal__BV_label_" :for="'inputHorizontal'+ index" class="col-form-label">{{field.label || snakeCaseToTitleCase(field.key)}}<small class="text-danger" v-if="field.required"> *</small></label>
        </b-col>
        <b-col>
          <component :id="'input-' + index" v-model="item[field.key]" v-if="field.componentEdit" :is="fields.find(x => x.key === field.key).componentEdit(item[field.key], field.key, item).is" v-b-tooltip.html v-bind="fields.find(x => x.key === field.key).componentEdit(item[field.key], field.key, item).props" v-on="fields.find(x => x.key === field.key).componentEdit(item[field.key], field.key, item).on"></component>
          <b-form-select v-else-if="field.type === 'select' && initialized" v-model="item[field.key]" :options="setFieldOptions(field.options, field.withSelect)" :required="field.required">
            <template #first>
              <option :value="null" v-translate>Select</option>
            </template>
          </b-form-select>
          <b-row v-else-if="field.type === 'datetime' && item[field.key + 'DateTimeParts']">
            <b-col><b-form-input type="date" v-model="item[field.key + 'DateTimeParts'][0]" :required="field.required"></b-form-input></b-col>
            <b-col><b-form-input type="time" v-model="item[field.key + 'DateTimeParts'][1]" :required="field.required"></b-form-input></b-col>
          </b-row>
          <b-form-timepicker v-else-if="field.type === 'time'" v-model="item[field.key]" :minutes-step="field.step || 1" :required="field.required" :state="!field.required || !!item[field.key] && field.required && item[field.key] !== null"></b-form-timepicker>
          <b-form-textarea v-else-if="field.type === 'textarea'" :id="'inputHorizontal'+ index" v-model="item[field.key]" :required="field.required" />
          <b-form-input v-else-if="field.type !== Boolean" :id="'inputHorizontal'+ index" :type="field.type === 'integer' ? 'number' : (field.type || 'text')" :step="field.type === 'integer' ? 1 : (field.step || null)" v-model="item[field.key]" :required="field.required" />
          <b-form-select v-else v-model="item[field.key]" :options="[{value: 1, text: $gettext('Yes')}, {value: 0, text: $gettext('No')}]" />
          <small tabindex="-1" class="form-text text-muted" v-if="field.description" v-html="field.description"></small>
        </b-col>
      </b-form-row>
      <b-button type="submit" variant="primary" v-translate>Submit</b-button>
    </b-form>
  </b-container>
</template>
<script>
export default {
  name: 'ApiItemNew',
  props: {
    type: {
      type: String,
      required: true
    },
    inModal: {
      type: Boolean,
      default: false
    },
    preData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      initialized: false,
      fields: this.$appConfig.models[this.type].fields.filter(el => el.key !== 'actions'),
      item: {},
      success: false,
      dismissSecs: 5,
      dismissCountDown: 0
    }
  },
  watch: {
    type: function (val) {
      this.fields = this.$appConfig.models[this.type].fields
    }
  },
  mounted() {
    // this.getItem()
    this.init()
  },
  methods: {
    async init() {
      for (let field of this.fields) {
        if (field.options && !Array.isArray(field.options)) {
          await this['fetch' + field.options.charAt(0).toUpperCase() + field.options.slice(1)]()
        }
        if (field.default !== undefined) {
          this.item[field.key] = field.default
        }
        if (field.type === 'datetime') {
          if (this.$appConfig.models[this.type].countrize || this.$appConfig.models[this.type].countrizeById) {
            const watchCountryKey = 'item.' + (this.$appConfig.models[this.type].countrize || this.$appConfig.models[this.type].countrizeById)
            this.$watch(
              watchCountryKey,
              (val) => {
                if (val) {
                  this.$tz = window.countries.find(x => x.iso_code === val || x.id === val).front_config.i18n.tz
                  this.moment.tz.setDefault(this.$tz)
                }
              },
              {
                immediate: true
              }
            )
          }
          this.item[field.key + 'DateTimeParts'] = []
        }
      }
      this.item = {...this.item, ...this.preData}
      this.initialized = true
    },
    getItem() {
      this.$http.get(this.$appConfig.api.baseUrl + this.$appConfig.models[this.type].endpoint + '/' + this.id)
        .then(response => {
          this.item = response.body
        })
    },
    postItem() {
      for (let field in this.fields) {
        if (this.fields[field].toLowerCase) {
          this.item[this.fields[field].key] = this.item[this.fields[field].key].toLowerCase()
        }
        if (this.fields[field].type === 'time' && !this.fields[field].withSeconds && this.item[this.fields[field].key].split(':').length === 3) {
          const timeParts = this.item[this.fields[field].key].split(':')
          this.item[this.fields[field].key] = `${timeParts[0]}:${timeParts[1]}`
        }
        if (this.fields[field].type === 'datetime') {
          if (this.item[this.fields[field].key + 'DateTimeParts'].length > 0) {
            this.item[this.fields[field].key] = this.moment.tz(this.item[this.fields[field].key + 'DateTimeParts'].join(' '), this.$tz).utc().format('YYYY-MM-DD HH:mm:ss')
          } else {
            this.item[this.fields[field].key] = null
          }
        }
      }
      this.$http.post(this.$appConfig.api.baseUrl + this.$appConfig.models[this.type].endpoint, this.item)
        .then(response => {
          this.showAlert()
          this.item = response.body
          if (!this.inModal) {
            this.$router.push('/list/' + this.$appConfig.models[this.type].endpoint, { query: { created: true } })
          } else {
            this.$emit('success', this.item)
          }
        })
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    snakeCaseToTitleCase(str) {
      return str.replace(/_/g, ' ').replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        }
      )
    },
    setFieldOptions(fetch, options = false) {
      if (!Array.isArray(fetch)) {
        if (fetch === 'shippingStatusReasons') {
          return Object.entries(this.shippingStatusReasons).reduce((a, [key, value], i) => (
            a.concat(value.map(y => {
              return {
                text: key + ' - ' + y.name,
                value: y.reason_id
              }
            }))
          ), [])
        } else if (!options) {
          return this[fetch]
        } else {
          return this[fetch + 'Select']
        }
      } else {
        return fetch
      }
    }
  }
}
</script>
